import { render } from "./MealPlanInfoCard.vue?vue&type=template&id=b56cd33a&scoped=true"
import script from "./MealPlanInfoCard.vue?vue&type=script&lang=js"
export * from "./MealPlanInfoCard.vue?vue&type=script&lang=js"

import "./MealPlanInfoCard.vue?vue&type=style&index=0&id=b56cd33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b56cd33a"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import MultiSelectInput from "@/components/neue/MultiSelectInput.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordRow from "@/components/customers/record/RecordRow.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { BasicSpinner, ConfirmModal, MultiSelectInput, RecordButton, RecordRow, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, ConfirmModal, MultiSelectInput, RecordButton, RecordRow, TheModal }, script.__o.components);}